import React from "react";

export const ThumbsUp = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5140_40368)">
      <path
        d="M9.5105 5.49988L9.6785 4.47939C9.72255 4.20998 9.69333 3.93368 9.5939 3.67944C9.49447 3.42521 9.3285 3.2024 9.11337 3.03435C8.89824 2.8663 8.64187 2.75921 8.37112 2.72429C8.10038 2.68938 7.82523 2.72792 7.5745 2.83588C7.22798 2.99139 6.94961 3.26728 6.791 3.61238L5.8585 5.49988H3.5C3.10218 5.49988 2.72064 5.65792 2.43934 5.93922C2.15804 6.22053 2 6.60206 2 6.99989V11.4999C2 11.8977 2.15804 12.2792 2.43934 12.5605C2.72064 12.8418 3.10218 12.9999 3.5 12.9999H13.009L14 7.48139L14.008 5.49988H9.5105ZM3 11.4999V6.99989C3 6.86728 3.05268 6.7401 3.14645 6.64633C3.24021 6.55256 3.36739 6.49988 3.5 6.49988H5.5V11.9999H3.5C3.36739 11.9999 3.24021 11.9472 3.14645 11.8534C3.05268 11.7597 3 11.6325 3 11.4999ZM13 7.34988L12.165 11.9999H6.5V6.45439L7.7095 4.00438C7.75045 3.93028 7.80841 3.86695 7.87861 3.81961C7.94881 3.77227 8.02924 3.74226 8.11329 3.73206C8.19734 3.72186 8.28262 3.73175 8.3621 3.76093C8.44158 3.7901 8.51301 3.83773 8.5705 3.89988C8.61962 3.95701 8.65554 4.02427 8.67567 4.09687C8.69581 4.16947 8.69968 4.24562 8.687 4.31988L8.3275 6.49988H13V7.34988Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5140_40368">
        <rect width="12" height="12" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);
